import { render } from 'react-dom';
import React from 'react';
import { Router, Route } from 'react-router';
import { Provider } from 'mobx-react';
import { hashHistory } from 'react-router';
import getApplicationRouter from 'pages/1212';
import dashboardStore from './stores/1212Store';
import groupInfoStore from './stores/groupInfoStore';
import textStore from './stores/TextStore';
import './index-1212.less';
import '../css/animation.less';
import '@ali/aps/dist/css/aps.css';
import 'babel-polyfill';

let store = {
  dashboardStore,
  groupInfoStore,
  textStore,
};
render(
  <Provider {...store}>
    <Router history={hashHistory}>
      <Route>{getApplicationRouter()}</Route>
    </Router>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/scripts/index-1212.js